import { render, staticRenderFns } from "./ListCaixasItens.vue?vue&type=template&id=4f9dea2c"
import script from "./ListCaixasItens.vue?vue&type=script&lang=js"
export * from "./ListCaixasItens.vue?vue&type=script&lang=js"
import style0 from "./ListCaixasItens.vue?vue&type=style&index=0&id=4f9dea2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports